document.addEventListener("DOMContentLoaded", function () {
  // --------------------------------------------------------------------------------------------------------------------------------------- DOM ELEMENT REFERENCES
  const homeHeaderWrapper = document.querySelector('.customHeader'); //Header applied on homepage
  const globalHeaderWrapper = document.querySelector('.globalHeader'); //Header applied on whole website
  
  let lastScrollTop = 0;

  let isMenuCollapsed = false;

  const blueSrc = 'https://cdn.shopify.com/s/files/1/0800/7319/5840/files/marinella-logo-dark.svg?v=1699972221'; // Blue full logo
  const bluenameSrc = 'https://cdn.shopify.com/s/files/1/0800/7319/5840/files/Marinella_logo_name_blue.png?v=1750235538'; // Blue logo text only
    
  function getDeviceType() {
      const width = window.innerWidth;
    
      if (width <= 768) {
        return 'mobile';
      } else if (width >= 769 && width <= 1300) {
        return 'tablet';
      } else {
        return 'desktop';
      }
  }

  let deviceType = getDeviceType(); // Inizializza riconoscendo il device utilizzato per la navigazione (desktop, tablet o mobile)
  // Brakpoints sono: da 0px a 768px, da 769px a 1300px, da 1300px in su


  //***************************************************************
  //********** LOCK/UNLOCK BODY SCROLL ON MENU HOVER ***************

    const homeNav = document.querySelector(".homeNav"); // Prima lista del menù, utilizzato per bloccare lo scroll del body quando il menù è in hover
    const mainNav = document.querySelector(".main-nav"); // Prima lista del menù, utilizzato per bloccare lo scroll del body quando il menù è in hover

    if (homeNav) {
      let noScrollTimeout; // variabile per memorizzare il timeout

      homeNav.addEventListener("mouseenter", () => {
        // imposta un delay di 1000ms prima di aggiungere la classe
        noScrollTimeout = setTimeout(() => {
          document.body.classList.add("no-scroll");
        }, 1000);
      });

      homeNav.addEventListener("mouseleave", () => {
        // cancella il timeout se il mouse esce prima dei 500ms
        clearTimeout(noScrollTimeout);
        document.body.classList.remove("no-scroll");
      });
    } else if (mainNav){
        let noScrollTimeout; // variabile per memorizzare il timeout

        mainNav.addEventListener("mouseenter", () => {
          // imposta un delay di 1000ms prima di aggiungere la classe
          noScrollTimeout = setTimeout(() => {
            document.body.classList.add("no-scroll");
          }, 1000);
        });

        mainNav.addEventListener("mouseleave", () => {
          // cancella il timeout se il mouse esce prima dei 500ms
          clearTimeout(noScrollTimeout);
          document.body.classList.remove("no-scroll");
        });
      }
      

  //************************************
  //********** LOGO CODE ***************

  if(homeHeaderWrapper){ //Check if user is on homepage and only then trigger the following code

    const announcementBarHomeWrapper = document.querySelector('.announcementHome'); //Announcement bar applied on homepage
    const announcementBarHome = announcementBarHomeWrapper?.querySelector('announcement-bar'); //Announcement bar applied on homepage
    const homeHeader =  homeHeaderWrapper?.querySelector('.header'); // Homepage header
    const menu = document.querySelector('.main-menu'); //Website menu section
    const homeLogoWrapper = document.querySelector('.home-logo-wrapper'); //Website logo in header on homepage
    const homeLogo = homeLogoWrapper?.querySelector('img'); //Website logo in header on homepage
    const homeBurger = document.querySelector('.main-menu__toggle'); //Burger menu icon in homepage
    let isMobileMenuOpen = 0;
  
    const originalSrc = homeLogo.src; // White full logo
    
    // -------------------------------------------------------------------------------------------- SET INITIAL LOGO STATE
    if (deviceType === 'tablet') {
    homeLogo.src = blueSrc;
    } else {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop === 0) {
        homeLogo.src = originalSrc;
      }
    }

    // ----------------------------------------------------------------- SET HEADER AS "NOT SCROLLED" ON PAGE LOAD TO APPLY CORRECT STYLE ON PAGE LOAD
    homeHeader.classList.add('not-scrolled');

    
    //************************************
    //HOME HEADER HOVER EFFECTS TO CHANGE LOGO

    // ---------------------------------------------------------------------- ANNOUNCEMENT BAR, HEADER AND LOGO TRANSFORMATIONS ON HOME AND DESKTOP ONLY WHEN HOVER
    if (deviceType === 'desktop'){

      // ------------------------------------------------------------------------------------------ CHANGE BRAND LOGO TO BLUE ON HEADER HOVER (HOME AND DESKTOP ONLY)
      homeHeader.addEventListener('mouseenter', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
         if (deviceType === 'desktop' && scrollTop === 0) {
            homeLogo.src = blueSrc;
          }
      });
  
      // ----------------------------------------------------------------------- BACK TO WHITE BRAND LOGO ON MOUSE LEAVE FROM HEADER IF HEADER NOT SCROLLED (HOME AND DESKTOP ONLY)
      homeHeader.addEventListener('mouseleave', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
       if (deviceType === 'desktop' && scrollTop === 0) {
          homeLogo.src = originalSrc;
        } 
      });      

      homeHeaderWrapper.addEventListener('mouseenter', () => { // Change announcement bar background color to blue on header hover (HOME AND DESKTOP ONLY)
        announcementBarHome.classList.add('indirectHover');
      });

      homeHeaderWrapper.addEventListener('mouseleave', () => { // Back to transparent announcemente bar on mouse leave from header (HOME AND DESKTOP ONLY)
        announcementBarHome.classList.remove('indirectHover');
      });

      homeHeaderWrapper.addEventListener('mouseleave', () => { // Turn header to white background and change logo to blue if hover on announcement bar  (HOME AND DESKTOP ONLY)
        announcementBarHome.classList.remove('indirectHover');
      });

      announcementBarHome.addEventListener('mouseenter', () => { // Back to transparent header and white logo on mouse leave from announcement bar only if page not scrolled (HOME AND DESKTOP ONLY)
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        homeHeader.classList.add('indirectHover');
        if (deviceType === 'desktop' && scrollTop === 0){
          homeLogo.src = blueSrc;
        }
      });

      announcementBarHome.addEventListener('mouseleave', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        homeHeader.classList.remove('indirectHover');          
          if (deviceType === 'desktop' && scrollTop === 0) {
            homeLogo.src = originalSrc;
          }
      });
    }

    // ---------------------------------------------------------------------------------------- LOGO UPDATE ON SCREEN RESIZE
    window.addEventListener('resize', () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (deviceType === 'tablet') {
        homeLogo.src = blueSrc;
      } else if (deviceType != 'tablet' && scrollTop === 0) {
          homeLogo.src = originalSrc;
        } else if (deviceType != 'tablet' && scrollTop > lastScrollTop) {
           homeLogo.src = blueSrc;
        }
      
    });

    //************************************
    //HOME HEADER SCROLL EVENT HANDLER

   
      window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (deviceType){ // If device type is detected, which is always true
          if (scrollTop > lastScrollTop) { // Scrolling down
            if (deviceType === 'desktop' /*|| deviceType === 'tablet'*/){ // On desktop and tablet
              menu.classList.add('menu--collapse');
              isMenuCollapsed = true;
            }
            
            if (deviceType === 'mobile' || deviceType === 'desktop'){ // On mobile and desktop
              announcementBarHome.classList.add('scrolled');
              homeHeader.classList.remove('not-scrolled');
              homeHeader.classList.add('scrolled');
              homeLogo.classList.add('reduced');
              homeLogo.src = bluenameSrc;
            }
          }else if (scrollTop < lastScrollTop) { // Scrolling up
              if((deviceType === 'desktop' /*|| deviceType === 'tablet'*/) && isMenuCollapsed){
                menu.classList.remove('menu--collapse');
                isMenuCollapsed = false;
              }
            }
            
          if (scrollTop === 0) { //  When 0 scroll
            if (deviceType != 'tablet'  && !isMenuCollapsed){ // On mobile and desktop
              homeHeader.classList.remove('scrolled');
              homeHeader.classList.add('not-scrolled');
              announcementBarHome.classList.remove('scrolled');
              homeLogo.classList.remove('reduced');
              homeLogo.src = originalSrc;
              if(deviceType === 'desktop'){ // Specifically for desktop
              menu.classList.remove('menu--collapse');
              isMenuCollapsed = false;
            }
            }else if (deviceType === 'tablet'  && isMenuCollapsed) { // Specifically for tablet
            //menu.classList.remove('menu--collapse');
            isMenuCollapsed = false;
            homeLogo.classList.remove('reduced');
            homeLogo.src = blueSrc;
            }
          }
          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        }
      });
    
   

   homeBurger.addEventListener('click', (event) => {
     if (event.target !== event.currentTarget) return;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    isMobileMenuOpen++; // Increment on each click
  
    if (isMobileMenuOpen % 2 === 1) { // Odd: menu open
      announcementBarHome.classList.add('mobileOpen');
      homeHeader.classList.add('mobileOpen');
       if (scrollTop === 0){
        homeLogo.src = originalSrc;
        } else {
           homeLogo.src = bluenameSrc;
        }
      homeLogo.src = blueSrc;
    } else { // Even: menu closed
      announcementBarHome.classList.remove('mobileOpen');
      homeHeader.classList.remove('mobileOpen');
      
        if (scrollTop === 0){
        homeLogo.src = originalSrc;
        } else{
           homeLogo.src = bluenameSrc;
        }
    }

    //************************************
    //HOME HEADER SCROLL EVENT HANDLER

  });

  window.addEventListener('resize', () => {
    deviceType = getDeviceType(); // aggiorna il valore a ogni resize
  });
    
  } // -----------------------------------------------------------------------------------------------------------------------End of 'if(homeHeaderWrapper)'
 
}); // End of 'document.addEventListener("DOMContentLoaded")'